"use client";

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "../../../assets/css/CategoryProductManagement.min.css";

export default function CategoryManagementSection ({ searchQuery = "", onSectionChange }) {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [deleteLoading, setDeleteLoading] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch("https://leapatinternational.com/admin/api/v1/category.php");

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();
                setData(result.data);
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const handleAddCategory = () => {
        navigate("/dashboard/add-category");
    };

    const handleEditCategory = (category) => {
        // Navigate to edit page with category ID
        navigate(`/dashboard/edit-category/${category.id}`);

        // Alternative: If you want to pass data through state
        // navigate(`/dashboard/edit-category/${category.id}`, {
        //   state: { categoryData: category }
        // })
    };

    const handlePreviewCategory = (category) => {
        // You can implement preview functionality here
        toast.info("Preview functionality coming soon!");
    };

    const handleDeleteCategory = async (categoryId) => {
        if (!window.confirm("Are you sure you want to delete this category?")) {
            return;
        }

        try {
            setDeleteLoading(categoryId);

            const data = new FormData();
            data.append("id", categoryId);

            const response = await fetch("https://leapatinternational.com/admin/api/v1/delete_category.php", {
                method: "POST",
                body: data,
            });

            const result = await response.json();

            if (result.status === "success") {
                setData((prev) => prev.filter((cat) => cat.id !== categoryId));
                toast.success("Category deleted successfully!");
            } else {
                toast.error(result.message || "Failed to delete category");
            }
        } catch (err) {
            console.error("Error:", err);
            toast.error("Network error. Please try again.");
        } finally {
            setDeleteLoading(null);
        }
    };

    // Calculate stats from data
    const stats = {
        total: data.length,
        active: data.filter((c) => c.status === "Active").length,
        inactive: data.filter((c) => c.status === "Inactive").length,
        totalProducts: data.reduce((sum, cat) => sum + (cat.productCount || 0), 0),
    };

    if (loading) {
        return (
            <div className="category-management-section">
                <div className="loading-spinner">
                    <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="category-management-section">
                <div className="alert alert-danger" role="alert">
                    Error: {error}
                </div>
            </div>
        );
    }

    return (

        <div className="category-management-section">
            <div className="row mb-4">
                <div className="col-12">
                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            <h1 className="page-title">Category Management</h1>
                            <p className="page-subtitle">Manage product categories and their details</p>
                        </div>
                        <button className="add-button" onClick={handleAddCategory}>
                            <i className="bi bi-plus-lg icon-white" style={{ color: 'white', marginRight: '5px' }}></i>Add Category
                        </button>
                    </div>
                </div>
            </div>

            {/* Stats Cards */}
            {/* <div className="row mb-4">
                <div className="col-lg-3 col-md-6 mb-3">
                    <div className="card stat-card">
                        <div className="card-body">
                            <div className="stat-content">
                                <div className="stat-icon">📂</div>
                                <div className="stat-details">
                                    <h3 className="stat-value">{stats.total}</h3>
                                    <p className="stat-title">Total Categories</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 mb-3">
                    <div className="card stat-card">
                        <div className="card-body">
                            <div className="stat-content">
                                <div className="stat-icon">✅</div>
                                <div className="stat-details">
                                    <h3 className="stat-value">{stats.active}</h3>
                                    <p className="stat-title">Active Categories</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 mb-3">
                    <div className="card stat-card">
                        <div className="card-body">
                            <div className="stat-content">
                                <div className="stat-icon">📦</div>
                                <div className="stat-details">
                                    <h3 className="stat-value">{stats.totalProducts}</h3>
                                    <p className="stat-title">Total Products</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 mb-3">
                    <div className="card stat-card">
                        <div className="card-body">
                            <div className="stat-content">
                                <div className="stat-icon">🔄</div>
                                <div className="stat-details">
                                    <h3 className="stat-value">{stats.inactive}</h3>
                                    <p className="stat-title">Inactive Categories</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

            {/* Categories Table */}
            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header">
                            <h5 className="card-title mb-0">Categories List</h5>
                        </div>
                        <div className="card-body">
                            {data.length > 0 ? (
                                <div className="content-table">
                                    <div className="table-responsive">
                                        <table className="table table-hover">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: '15%' }}>Id</th>
                                                    <th style={{ width: '25%' }}>Title</th>
                                                    <th style={{ width: '15%' }}>Image</th>
                                                    <th style={{ width: '15%' }}>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data.map((item) => (
                                                    <tr key={item.id}>
                                                        <td>
                                                            <h6 className="content-title">{item.id}</h6>
                                                        </td>
                                                        <td>
                                                            <div className="content-info">
                                                                <h6 className="content-title">{item.title}</h6>
                                                                <span className="content-category">{item.category}</span>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <img
                                                                src={item.image || "/placeholder.svg"}
                                                                className="category-image"
                                                                alt={item.title}
                                                                onError={(e) => {
                                                                    e.target.src = "/placeholder.svg";
                                                                }}
                                                            />
                                                        </td>
                                                        <td>
                                                            <div className="action-buttons">
                                                                <button
                                                                    className="btn btn-sm btn-outline-primary"
                                                                    title="Edit"
                                                                    onClick={() => handleEditCategory(item)}
                                                                >
                                                                    ✏️
                                                                </button>

                                                                <button
                                                                    className="btn btn-sm btn-outline-danger"
                                                                    title="Delete"
                                                                    onClick={() => handleDeleteCategory(item.id)}
                                                                    disabled={deleteLoading === item.id}
                                                                >
                                                                    {deleteLoading === item.id ? (
                                                                        <span
                                                                            className="spinner-border spinner-border-sm"
                                                                            role="status"
                                                                            aria-hidden="true"
                                                                        ></span>
                                                                    ) : (
                                                                        "🗑️"
                                                                    )}
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            ) : (
                                <div className="text-center py-5">
                                    <div className="empty-state">
                                        <div className="empty-icon">📂</div>
                                        <h5>No categories found</h5>
                                        <p className="text-muted">
                                            {searchQuery ? `No categories match "${searchQuery}"` : "Start by adding your first category"}
                                        </p>
                                        {!searchQuery && (
                                            <button className="btn btn-primary" onClick={handleAddCategory}>
                                                <i className="bi bi-plus-lg icon-white" style={{ color: 'white', marginRight: '5px' }}></i> Add First Category
                                            </button>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
